import { isObject } from '../utils/utils';
export const isArrayOfObjects = options => {
  return typeof options[0] === 'object';
};
export const defaultGetOptionValue = value => {
  return isObject(value) ? value.value : value;
};
export const defaultGetOptionLabel = value => {
  return isObject(value) ? value.label : String(value);
};